import {CATEGORYASTRO_FETCH_DATA_SUCCESS, CATEGORYASTRO_HAVE_ERROR, CATEGORYASTRO_ARE_LOADING } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function CategoryAstroReducer (state = initialState, action) {
    switch (action.type) {
        case CATEGORYASTRO_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case CATEGORYASTRO_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case CATEGORYASTRO_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.categoryAstro,
                loading:false,
            }

        default:
            return state;
    }
}
